import axios from 'axios';
import {
    PagesTypes
} from 'actions/types';

export function wlFetchPages() {
    return (dispatch, getState) => {
        const host = getState().config.get('host');
        const headers = getState().config.get('headers').toJSON();
        const route = getState().links.getIn(['getPages', 'href'])
        const url = `${host}${route}`;
        const method = 'GET';

        dispatch({
            type: PagesTypes.WL_FETCH_PAGES,
            payload: {
                headers: headers,
                method: method,
                url: url
            }
        })
        return axios( {
            method,
            headers,
            url
        } )
        .then(response => {
            return dispatch(wlSetPages(response.data));
        })
        .catch(error => {
            throw error
        })
    }
}

export function wlSetPages(args) {
    return {
        type: PagesTypes.WL_SET_PAGES,
        payload: args
    }
}